import api from './api';
import { Client, ClientSummary, PageResponse, TypeClient } from '../types';

export const clientService = {
  getAll: () => api.get<ClientSummary[]>('/api/clients').then((r) => r.data),
  getPage: (params: {
    page: number;
    size: number;
    q?: string;
    type?: 'TOUS' | TypeClient;
    vehicule?: string;
  }) =>
    api.get<PageResponse<ClientSummary>>('/api/clients/page', {
      params: {
        page: params.page,
        size: params.size,
        ...(params.q?.trim() ? { q: params.q.trim() } : {}),
        ...(params.type && params.type !== 'TOUS' ? { type: params.type } : {}),
        ...(params.vehicule?.trim() ? { vehicule: params.vehicule.trim() } : {}),
      },
    }).then((r) => r.data),
  getById: (id: number) => api.get<Client>(`/api/clients/${id}`).then((r) => r.data),
  getResume: (id: number) => api.get<ClientSummary>(`/api/clients/${id}/resume`).then((r) => r.data),
  search: (nom: string) => api.get<Client[]>('/api/clients/search', { params: { nom } }).then((r) => r.data),
  create: (data: Partial<Client>) => api.post<Client>('/api/clients', data).then((r) => r.data),
  update: (id: number, data: Partial<Client>) => api.put<Client>(`/api/clients/${id}`, data).then((r) => r.data),
  delete: (id: number) => api.delete(`/api/clients/${id}`),
};
